import { render, staticRenderFns } from "./toggle.vue?vue&type=template&id=1f4b5f66&"
import script from "./toggle.ts?vue&type=script&lang=ts&"
export * from "./toggle.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports